import FormSelect from "components/form/FormSelect";
import FormText from "components/form/FormText";
import IndicatorButton from "components/indicator/IndicatorButton";
import { AppHelper } from "helpers/appHelper";
import { useApiState } from "hooks/useApiState";
import { useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useForm } from "react-hook-form";
import ReactModal from "react-modal";
import { useRecoilState } from "recoil";
import { AcctState } from "stores/atoms/acctState";
import { CompanyMemberSearchItemType } from "types/api/companyMemberSearchItemType";

/**
 * カンパニーメンバー招待モーダル
 */
export default function SettingModalMemberInvitation(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  membersInvitedState: CompanyMemberSearchItemType[];
  setMembersInvitedState: (members: CompanyMemberSearchItemType[]) => void;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type FormStateType = {
    mailAddress: string;
    roleDiv: number;
  };
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();

  const [acctState] = useRecoilState(AcctState);

  const { postInvitationSend } = useApiState();
  const [processing, setProcessing] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<FormStateType>();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const onClose = () => {
    props.setOpen(false);
  };

  /**
   * 招待送信ボタン押下時の処理
   */
  const onSend = () =>
    AppHelper.submit(
      processing,
      setProcessing,
      handleSubmit(async (data: FormStateType) => {
        try {
          // 招待送信APIの呼び出し
          const response = await postInvitationSend({
            companyId: acctState.company.id,
            mailAddress: data.mailAddress,
            roleDiv: data.roleDiv,
          });

          // APIのエラー処理
          if (response.member == null) {
            setError("mailAddress", {
              type: "custom",
              message: "このメールアドレスはすでに登録されています。",
            });
            return;
          }
          // 呼び出し元画面に登録したメンバーを追加
          props.setMembersInvitedState([
            ...props.membersInvitedState,
            {
              user: null,
              member: response.member,
            },
          ]);
          // モーダルを閉じる
          onClose();
        } catch (e) {
          showBoundary(e);
        }
      })
    );

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        // onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: "rgba(30, 30, 30,0.5)",
          },
          content: {
            maxWidth: "600px",
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div className="modal-content rounded-4">
          <div className="modal-header border-bottom-0">
            <button
              onClick={onClose}
              type="button"
              className="btn-close btn-circle-close"
              aria-label="Close"
            >
              <img src="/img/icon/multiply.svg" alt="x" />
            </button>
          </div>
          <div className="card card-detail">
            <div className="card-body">
              <h2 className="card-title text-start">ユーザーの追加</h2>
              <p className="lead text-center mb-4">
                ユーザーを「{acctState.company.name}」に招待します。
              </p>

              <div className="form-group">
                <FormText
                  subject="メールアドレス"
                  name="mailAddress"
                  register={register}
                  errors={errors}
                  required={true}
                  maxLength={300}
                  format="email"
                  requiredMark={true}
                />
              </div>
              <div className="form-group">
                <FormSelect
                  subject="ユーザー権限"
                  name="roleDiv"
                  register={register}
                  errors={errors}
                  options={AppHelper.getDivSelectOptions("role")}
                  required={true}
                  blank={true}
                  blankLabel="選択してください"
                  requiredMark={true}
                />
              </div>

              <div className="mb-5"></div>
              <div className="d-md-flex d-flex-header">
                <div className="flex-grow-1 flex-right">
                  <ul className="list-inline list-btn mb-0">
                    <li className="list-inline-item">
                      <button
                        type="button"
                        className="btn btn-common btn-common-w147 moderate-blue"
                        onClick={onSend}
                        disabled={processing}
                      >
                        <IndicatorButton visible={processing} />
                        招待する
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
